const question = {
    highlyImportant: { point: [1] },
    important: { point: [2] },
    notImportant: { point: [3] },
};

export default question;
